export const BrandLogo = [
  {
    //스텝포넷제로
    activeSrc: "/icons/brand/스텝포 로고.png",
    inactiveSrc: "/icons/brand/스텝포 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_스텝포.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%8A%A4%ED%85%9D%ED%8F%AC%EB%84%B7%EC%A0%9C%EB%A1%9C",
    pcode:
      "P2503281523411674,P2205311704118515,P2210190939214050,P2301171108094628,P2308221520262025",
  },
  {
    //리펄프
    activeSrc: "/icons/brand/리펄프 로고.png",
    inactiveSrc: "/icons/brand/리펄프 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_리펄프.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EB%A6%AC%ED%8E%84%ED%94%84%ED%85%8C%EC%9D%B4%ED%94%84",
    pcode:
      "P2307261403244664,P2403211814230907,P2403211744090311,P2407171416573973,P2309151538424038",
  },

  {
    //에코날개박스
    activeSrc: "/icons/brand/에코날개박스 로고.png",
    inactiveSrc: "/icons/brand/에코날개박스 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_에코날개박스.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%97%90%EC%BD%94%EB%82%A0%EA%B0%9C%EB%B0%95%EC%8A%A4",
    pcode:
      "P2103221606263171,P2405311440501766,P2405281800316659,P2503201052177017,P2104121054162729",
  },
  {
    //우림
    activeSrc: "/icons/brand/우림 로고1.png",
    inactiveSrc: "/icons/brand/우림 로고 비활성1.png",
    mainBannerImg: "/img/brand/제휴배너_우림.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%9A%B0%EB%A6%BC",
    pcode:
      "P2308171343553418,P2204271140076716,P2103171930517715,P2204271106380718,P2406241714411655",
  },

  {
    //아세아상자세상
    activeSrc: "/icons/brand/아세아상자세상 로고.png",
    inactiveSrc: "/icons/brand/아세아상자세상 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_아세아상자세상.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%95%84%EC%84%B8%EC%95%84",
    pcode:
      "P2401191414587994,P2401191414592645,P2606261608258090,P2606291128480092,P2401191414590601",
  },
  {
    //안박스
    activeSrc: "/icons/brand/안박스 로고.png",
    inactiveSrc: "/icons/brand/안박스 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_안박스.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EC%95%88%EB%B0%95%EC%8A%A4",
    pcode:
      "P2504291348167792,P2504291348171810,P2504291348171486,P2504291348168392,P2504291348179244",
  },
  {
    //박스다사
    activeSrc: "/icons/brand/박스다사 로고.png",
    inactiveSrc: "/icons/brand/박스다사 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_박스다사.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?garo=&sero=&high=&erange=&search=%EB%B0%95%EC%8A%A4%EB%8B%A4%EC%82%AC",
    pcode:
      "P2411201507376094,P2411201555118460,P2411201504188240,P2505141443032998,P2505141443022565",
  },
  {
    //리그라운드
    activeSrc: "/icons/brand/리그라운드 로고.png",
    inactiveSrc: "/icons/brand/리그라운드 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_리그라운드.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?search=%EB%A6%AC%EA%B7%B8%EB%9D%BC%EC%9A%B4%EB%93%9C",
    pcode:
      "P2102261108119945,P2407171015395017,P2102261242112535,P2103011425037703,P2102261839508771",
  },
  {
    //박스마루
    activeSrc: "/icons/brand/박스마루 로고.png",
    inactiveSrc: "/icons/brand/박스마루 로고 비활성.png",
    mainBannerImg: "/img/brand/제휴배너_박스마루.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/search/?search=%EB%B0%95%EC%8A%A4%EB%A7%88%EB%A3%A8",
    pcode:
      "P2409251545229382,P2409251512334924,P2409251101472560,P2409241735527469,P2409191417263521",
  },
  {
    //폴팩
    activeSrc: "/icons/brand/세모쇼핑백_활성.png",
    inactiveSrc: "/icons/brand/세모쇼핑백_비활성.png",
    mainBannerImg: "/img/brand/제휴배너_세모쇼핑백.png",
    mainBannerUrl:
      "https://www.caretstore.co.kr/products/Paper-Shooping-Bag/",
    pcode:
      "P2509021622311824,P2509021622357516,P2509021622365189,P2509021622368413,P2509021622358679",
  },
];
